import { utilsModule } from "../../utils-module";

function passwordResetConfirmPageController($scope,dialogs,UserIdha,$state,LoopBackAuth){

    var self = this;
    var ctrl = this;
    ctrl.password = '';
    ctrl.passwordConfirmation = '';

    ctrl.passwordMatch = function (): boolean {
        if (!ctrl || !ctrl.password || !ctrl.passwordConfirmation) {
            return false;
        }

        if (ctrl.password == ctrl.passwordConfirmation) {
            return true;
        } else {
            return false;
        }
    }

    ctrl.resetPassword = function(){
        ctrl.validated = true;
        if ($scope.forms.formId.$invalid){
            return;
        }
            
        var req = {newPassword:self.password}
        if (self.accessToken){
            LoopBackAuth.accessTokenId = self.accessToken;
        }
        
        UserIdha.setPassword(req).$promise            
        .then((result)=>{
            dialogs.info("Sua senha foi alterada com sucesso!!")
            $state.go("login");
        })
        .catch((err)=>{
            if (err.customMsg){
                dialogs.error(err.customMsg)
            }else{
                dialogs.error("Falha ao solicitar redefinição da senha!")
            }
        })            
    }

}

utilsModule.component('passwordResetConfirmPage', {
    template: require('./password-reset-confirm-page.component.html'),
    controller: ['$scope','dialogs','UserIdha','$state','LoopBackAuth',passwordResetConfirmPageController],
    bindings: {
        accessToken:'=',
        isOnLoginPage: '@'
    }
})
